export default __webpack_public_path__ + "static/media/lost-modal-bg.c1378684.jpg";